/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ic_edit_ = require('./ic_edit_.png');

var _ic_edit_2 = _interopRequireDefault(_ic_edit_);

var _config = require('util/config');

var _reactRouter = require('react-router');

require('./index.less');

var _tool = require('util/tool');

var _reactRedux = require('react-redux');

var _product = require('../../../../redux/actions/product');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = (0, _jsx3.default)('p', {}, void 0, '\u63A5\u5165\u8BBE\u5907\u6570');

var _ref2 = (0, _jsx3.default)('span', {}, void 0, '\u521B\u5EFA\u65F6\u95F4\uFF1A');

var _ref3 = (0, _jsx3.default)('p', {}, void 0, '\u67E5\u770B\u8BE6\u60C5');

var Item = function (_Component) {
    (0, _inherits3.default)(Item, _Component);

    function Item(props, context) {
        (0, _classCallCheck3.default)(this, Item);
        return (0, _possibleConstructorReturn3.default)(this, (Item.__proto__ || (0, _getPrototypeOf2.default)(Item)).call(this, props, context));
    }

    (0, _createClass3.default)(Item, [{
        key: 'copyText',
        value: function copyText(text) {
            _tool.copy.handle(text);
        }
    }, {
        key: 'editRouter',
        value: function editRouter(id) {
            this.props.router.push({
                pathname: '/edit/' + id
            });
        }
    }, {
        key: 'detailRouter',
        value: function detailRouter(id, type) {
            // console.log('------>>>', this.props)
            this.props.getEruipmentType(type);

            this.props.router.push({
                pathname: '/product/' + id
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            // console.log('[nextProps]...',nextProps)
            // console.log('[this.props]...',this.props)

        }
    }, {
        key: 'render',
        value: function render() {
            var _props$data = this.props.data,
                id = _props$data.id,
                name = _props$data.name,
                productTemplate = _props$data.productTemplate,
                pictureUrl = _props$data.pictureUrl,
                registerNumber = _props$data.registerNumber,
                factoryName = _props$data.factoryName,
                accessType = _props$data.accessType,
                createTime = _props$data.createTime,
                deviceCount = _props$data.deviceCount,
                productCode = _props$data.productCode;


            return (0, _jsx3.default)('div', {
                className: 'product-cont-item',
                onClick: this.detailRouter.bind(this, id, productTemplate),
                v: true
            }, void 0, (0, _jsx3.default)('div', {
                className: 'item-cont'
            }, void 0, (0, _jsx3.default)('div', {
                className: 'item-cont-left'
            }, void 0, (0, _jsx3.default)('div', {
                style: { backgroundImage: 'url(\'' + _config.target + pictureUrl + '\')' }
            }), (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)('div', {
                className: 'title'
            }, void 0, (0, _jsx3.default)('p', {}, void 0, name), (0, _jsx3.default)('span', {}, void 0, name)), (0, _jsx3.default)('div', {}, void 0, '\u8BBE\u5907\u7C7B\u578B\uFF1A', factoryName), (0, _jsx3.default)('div', {}, void 0, productTemplate === 2 ? '\u6CE8\u518C\u7801\uFF1A' + registerNumber : '\u4EA7\u54C1\u4EE3\u7801\uFF1A' + productCode), (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)('p', {}, void 0, '\u751F\u4EA7\u5382\u5546\uFF1A', factoryName), (0, _jsx3.default)('span', {}, void 0, factoryName)))), (0, _jsx3.default)('div', {
                className: 'item-cont-right'
            }, void 0, _ref, (0, _jsx3.default)('p', {}, void 0, (0, _jsx3.default)('span', {}, void 0, deviceCount), productTemplate === 2 ? '台' : '辆'))), (0, _jsx3.default)('div', {
                className: 'item-foot'
            }, void 0, (0, _jsx3.default)('p', {}, void 0, _ref2, createTime), _ref3));
        }
    }]);
    return Item;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
    // console.log(state.product.get('type'))
    return {
        type: state.product.get('type')
    };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, { getEruipmentType: _product.getEruipmentType })((0, _reactRouter.withRouter)(Item));

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/product/list/Item/index.jsx
// module id = 996
// module chunks = 0